import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { carregarConteudoRemoto } from './content';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Busca as edições feitas no painel e sobrepõe ao conteúdo
// embutido no build. Roda depois do primeiro render: a página
// aparece imediatamente com o texto do build (que é o que os
// buscadores indexam) e se atualiza quando a resposta chega.
//
// Falha em silêncio — API fora do ar não afeta o visitante.
carregarConteudoRemoto();
